import { getSuffixFunc } from '../../utils';
import { Suffix_List } from './constants';

const getSuffix = getSuffixFunc(Suffix_List);

export {
    getSuffix,
};
